import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Header from "../components/Header";
import MarketsView from "./MarketsView"; // ✅ Use the new swipeable component

const Markets = ( {isModalOpen, setIsModalOpen} ) => {
  return (
    <div className="markets-container" style={{ height: "100vh", overflow: "hidden" }}>
      <Header page="Markets" isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <Routes>
        {/* ✅ Redirect root "markets" to "/markets/watchlist/overview" */}
        <Route path="/" element={<Navigate to="/markets/watchlist/overview" />} />
        <Route path="watchlist/:watchlistId" element={<MarketsView />} />
      </Routes>
    </div>
  );
};

export default Markets;
